import { FunctionComponent } from "react";
import styled from "styled-components";
import variables from "../../theme/variables";
import Button from "../Button";

export type WizardProps = {
  isActive?: boolean;
  currentStep?: number;
  totalSteps?: number;
  firstStep?: () => any;
  lastStep?: () => any;
  nextStep?: () => any;
  previousStep?: () => any;
  goToStep?: (n: number) => any;
  previoustText?: string;
  nextText?: string;
  nextDisabled?: boolean;
  nextActive?: boolean;
  nextClick?: () => any;
  buttons?: JSX.Element[];
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: rgba(0, 0, 0, 0.534);
  color: white;
  padding: ${variables.SPACING * 2}px ${variables.SPACING * 4}px;
  z-index: 2;
  align-items: center;

  > div {
    height: 100%;
    margin-right: ${variables.SPACING * 2}px;

    > * {
      height: 100%;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  @media screen and (max-width: 411px) {
    padding: ${variables.SPACING * 2}px;
  }
`;

const FormNav: FunctionComponent<WizardProps> = ({
  currentStep,
  totalSteps,
  nextStep,
  previousStep,
  nextText,
  nextDisabled,
  nextActive,
  nextClick,
  buttons,
}) => {
  const isFirst = currentStep === 1;
  const isLast = currentStep === totalSteps;

  const onNextClick = () => {
    if (nextClick) {
      nextClick();
    }

    if (nextStep) {
      nextStep();
    }
  };

  const isNextActive = typeof nextActive === "undefined" ? true : nextActive;

  return (
    <Container>
      {!isFirst && (
        <div onClick={previousStep}>
          <Button>Previous</Button>
        </div>
      )}
      {!isLast && (
        <div onClick={onNextClick}>
          <Button disabled={nextDisabled} active={isNextActive}>
            {nextText || "Next"}
          </Button>
        </div>
      )}

      {buttons?.length && buttons}
    </Container>
  );
};

export default FormNav;
